import HeroBanner from './components/HeroBanner';
import HotGamesSection from './components/HotGamesSection';
import RankingSection from './components/RankingSection';
import CategoryEntrySection from './components/CategoryEntrySection';
import LatestArticlesSection from './components/LatestArticlesSection';

export default function Home() {
  return (
    <>
      <HeroBanner />
      <HotGamesSection />
      <RankingSection />
      <CategoryEntrySection />
      <LatestArticlesSection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '黄游戏',
            url: 'https://huangyouxi.com',
            description: '探索最新黄游戏资讯，汇聚热门黄游戏排行榜、玩法攻略、下载推荐与评测内容。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://huangyouxi.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '黄游戏',
            url: 'https://huangyouxi.com',
            description: '中文游戏资讯与攻略推荐平台',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@huangyouxi.com',
            },
          }),
        }}
      />
    </>
  );
}